var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30 0L30 30H23.4L23.4483 6.55172L0 6.6V1.14441e-06L30 0Z","fill":"#00FF85","key":0}),React.createElement("path",{"d":"M21.7588 3.84671L26.5588 8.64671L5.55881 29.6467L0.758808 24.8467L21.7588 3.84671Z","fill":"#00FF85","key":1})]);
}

ArrowRight.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 30 30","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
